import ApplicationController from "./application_component_controller"
import SlimSelect from "slim-select";
import { useOutlets } from "hb/insights/use_outlets"

export default class extends ApplicationController {
  static targets = ["select"];
  static values = {
    placeholder: String,
    noneResultsText: String,
    turboFrameId: String,
    settings: Object
  };

  connect() {
    let settings = {
      placeholderText: this.placeholderValue,
      searchText: this.noneResultsTextValue
    }

    if (this.settingsValue) {
      settings = { ...settings, ...this.settingsValue }
    }

    this.slimSelect = new SlimSelect({
      settings,
      select: this.selectTarget,
      events: {
        searchFilter: (option, search) => {
          return option.data.tokens?.toLowerCase().includes(search.toLowerCase());
        },
        afterChange: (options) => {
          // In an ideal world you could do this:
          // Turbo.visit($(e.currentTarget).val(), { frame: "instructions" })
          // ...but for data-turbo-action=advance to work, you must do this:
          if (this.hasTurboFrameIdValue && options[0].data.turboFrameSrc) {
            const frame = document.getElementById(this.turboFrameIdValue);
            const action = frame.getAttribute("data-turbo-action") || null;
            frame.delegate.proposeVisitIfNavigatedWithAction(frame, action);
            frame.src = options[0].data.turboFrameSrc;
          }

          this.dispatch("change", { detail: { options }});
        },
      },
    });

    useOutlets(this)
  }

  disconnect() {
    console.log("destroying");
    this.slimSelect.destroy();
  }
}
